import React from "react";
import Filter from "../Components/Filter";
import Cards from "./Cards";
import styled from "styled-components";
import { Flex, Input } from "@chakra-ui/react";
import {SearchIcon } from '@chakra-ui/icons'

const Funraise = () => {
  return (
    <div>
      <img
        src="https://i.postimg.cc/2ydGHJ4y/Screenshot-2022-08-24-102031.png"
        alt=""
        style={{ width: "100%", height: "300px", justifyContent: "center" }}
      />
      <br/>
      <br/>
      <Input width="50%" m={5} ml={500} placeholder="Search Fundraisers" icon={<SearchIcon colorScheme='blue'/>}/>
      <Flex justifyContent="center">
      {/* <Text as='b'>Showing Fundraisers for</Text> */}
      </Flex>
      <div style={{ display: "flex", justifyContent: "center",gap:"15px",width:"90%",margin:"auto" }}>
        <FilterWrapper>
          <Filter />
        </FilterWrapper>
        <CardWrapper>
          <Cards />
        </CardWrapper>
      </div>
      <br/>
      <br/>
    </div>
    
  );
};

export default Funraise;

const FilterWrapper = styled.div`
  width: 300px;
  height:fit-content;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 30px 60px -12px, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px;
`;

const CardWrapper = styled.div`
  width: 100%;
  height:130vh;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
  display: grid;
  grid-template-columns: repeat(3, minmax(300px, max-content));
  justify-content: center;
  grid-gap: 10px;
  overflow-y: scroll;
`;
